// dependencies
import axios from 'axios'
import React, { useState, useEffect, Fragment } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useStateValue } from './Utils/StateProvider'

import Dashboard from "./Routes/Dashboard";
import Login from "./Routes/Login";
import Online from "./Routes/Online";
import Register from "./Routes/Register";
import Header from "./Components/Header";
import Banner from "./Components/Banner";
import Reset from "./Routes/Reset";

import './Styles/App.css'
import './Styles/media.css'
import ProcessScreen from './Components/ProcessScreen';
import Info from './Components/Info';
import Flash from './Components/User/Flash';


function App() {
    const [{ url, activeTheme, processing, showHeader, notify }, payload] = useStateValue()
    const handleResize = () => {
        payload ({
            type: 'SET_DIMENSIONS'
        })
    }
    
    const getSiteData = async (source) => {
        try {
            const siteData = await axios.get(`${url}/site`, {
                cancelToken: source.token
            })
            document.title = `${siteData.data.data.name} || Online Banking`
            payload({
                type: 'SET_SITE',
                data: siteData.data.data
            })
        }catch (error) {
            // console.warn(error.message) 
        }
    }

    useEffect(() => {
        document.body.classList = activeTheme
        window.addEventListener('resize', handleResize)

        const source = axios.CancelToken.source()
        getSiteData(source)
        return () => {
            source.cancel()
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    return (
        <Fragment>
            <Router>
                {
                    processing && (
                        <ProcessScreen />
                    )
                }
                {
                    notify && (
                        <Info text={notify.text} type={notify.type} />
                    )
                }
                <Banner />
                {
                    showHeader && (
                        <Header />
                    )
                }
                <Flash />
                <Routes>
                    <Route path="/" exact element={<Login />} />
                    <Route path="/reg/:tool" element={<Register />} />
                    <Route path="/enroll" element={<Online />} />
                    <Route path="/reset" element={<Reset />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                </Routes>
            </Router>
        </Fragment>
    );
}

export default App;